import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Zap } from 'lucide-react';
import { formatPrice } from '../../utils/helpers';

/**
 * Single hero carousel slide — media + content panel only.
 */
export default function HeroSlide({ slide, isActive }) {
  const { t } = useTranslation('hero');

  if (!slide) return null;

  return (
    <article
      className={`hero-slide ${isActive ? 'hero-slide--active' : ''}`}
      aria-hidden={!isActive}
    >
      <img
        className="hero-slide__bg"
        src={slide.image}
        alt=""
        loading={isActive ? 'eager' : 'lazy'}
        decoding="async"
      />
      <div className="hero-slide__scrim" aria-hidden="true" />

      <div className="hero-slide__inner">
        <div className="hero-slide__panel">
          {slide.isFlash && (
            <div className="hero-flash-badge">
              <Zap size={18} aria-hidden />
              <span>{t('flashSale')}</span>
            </div>
          )}

          {slide.categoryName && (
            <p className="hero-slide__category">{slide.categoryName}</p>
          )}

          <h2 className="hero-slide__title">{slide.title}</h2>
          <p className="hero-slide__subtitle">{slide.subtitle}</p>

          {slide.price != null && (
            <div className="hero-slide__price">
              {slide.comparePrice > slide.price && (
                <span className="hero-price-old">{formatPrice(slide.comparePrice)}</span>
              )}
              <span className="hero-price-current">{formatPrice(slide.price)}</span>
              {slide.discount > 0 && (
                <span className="hero-discount-badge">-{slide.discount}%</span>
              )}
            </div>
          )}

          <Link to={slide.link} className="hero-slide__cta btn btn-primary">
            {slide.buttonText}
            <ArrowRight size={20} aria-hidden />
          </Link>
        </div>
      </div>
    </article>
  );
}
